<template>
  <q-page class="flex flex-center">
    <q-card>
      <q-card-section class="q-pa-md">
        <div class="text-h6 text-center">Login</div>
        <q-form @submit.prevent="onSubmit">
          <q-input filled v-model="loginForm.username" label="Username" class="q-mt-md" />
          <q-input filled v-model="loginForm.password" label="Password" type="password" class="q-mt-md" />
          <q-btn label="Login" type="submit" color="primary" class="full-width q-mt-md" />
        </q-form>
      </q-card-section>
    </q-card>
  </q-page>
</template>

<script>
import axios from 'axios';
import { login } from '../utils/auth'; // adjust path as necessary

export default {
  name: 'LoginPage',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      error: null
    };
  },
  methods: {
    async onSubmit() {
      try {
        const response = await axios.post('/api/v1/token/', {
          username: this.loginForm.username,
          password: this.loginForm.password
        });
        login(response.data); // Use the login method
        this.error = null;
        this.$router.push('/');
      } catch (error) {
        this.error = 'Failed to login. Please check your credentials.';
        console.error(error);
      }
    }
  }
}
</script>

